import React, { useCallback, useEffect, useRef, useState } from "react";
import { Button } from "primereact/button";
import ModalShell from "../../components/Modal/ModalShell";
import { notifySuccess, notifyWarning } from "../../services/notificationBus";

export default function AssignmentDeadlineDialog({ status, onReturn, onDownload }) {
  const [dismissed, setDismissed] = useState(false);
  const notified = useRef(new Set());
  const saved = status === "saved";
  const failed = status === "failed";
  const pending = !saved && !failed;

  const notifyResult = useCallback(() => {
    if (notified.current.has(status)) return;
    if (status === "saved") {
      notified.current.add(status);
      notifySuccess("Tiempo agotado. Tu evaluación se envió automáticamente.");
    } else if (status === "failed") {
      notified.current.add(status);
      notifyWarning("Tiempo agotado. No se pudo confirmar el último envío; conserva un respaldo de tus respuestas.");
    }
  }, [status]);
  useEffect(() => { if (dismissed) notifyResult(); }, [dismissed, notifyResult]);

  return <ModalShell visible={!dismissed} title="Tiempo agotado" width="32rem"
    className="player-deadline-dialog" okLoading={pending} onHide={() => setDismissed(true)}
    footer={<div className="assignment-dialog-actions">
      <Button type="button" text label="Ver respuestas" disabled={pending} onClick={() => setDismissed(true)} />
      {failed ? <Button type="button" icon="pi pi-download" label="Descargar respaldo" onClick={onDownload} />
        : <Button type="button" icon="pi pi-arrow-left" label={pending ? "Enviando respuestas..." : "Volver a mis asignaciones"}
          loading={pending} disabled={pending} onClick={() => { notifyResult(); onReturn(); }} />}
    </div>}>
    <div className={`player-deadline-result${saved ? " is-saved" : failed ? " is-failed" : ""}`} role="status" aria-live="polite" aria-atomic="true">
      <i className={`pi ${saved ? "pi-check-circle" : failed ? "pi-exclamation-triangle" : "pi-spin pi-spinner"}`} aria-hidden="true" />
      <div>
        <h2>{saved ? "Respuestas enviadas" : failed ? "Envío sin confirmar" : "Enviando tus respuestas"}</h2>
        <p>{saved ? "La evaluación se cerró y tus respuestas se enviaron automáticamente, incluidas las preguntas sin responder."
          : failed ? "No pudimos confirmar el envío de tus últimas respuestas. El servidor cerrará la evaluación con el último progreso que recibió."
            : "El tiempo para responder terminó. Estamos enviando tus últimas respuestas, aunque queden preguntas vacías."}</p>
        {failed && <p>Tus respuestas de esta pestaña siguen disponibles para descargar un respaldo.</p>}
      </div>
    </div>
  </ModalShell>;
}
